import TextFieldWithControl from '@components/ui/TextFieldWithControl';
import { Button, mq, Subtitle } from '@kvdbil/components';
import { useCallback } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ItemList } from './components/ItemList';
import { useSelector } from 'react-redux';
import { selectQuery } from '@data/selectors/itemSelectors';
import { useAppDispatch } from '@hooks/reduxHooks';
import { resetItems } from '@data/slices/itemSlice';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 1rem;

  background-color: ${({ theme }) => theme.colors.background.light};

  & > form {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;

    & > :first-child {
      flex-grow: 1;
    }

    & > button {
      font-size: 0.75rem;
    }
  }

  & > p {
    line-height: 1;
    padding-bottom: 0.75rem;
    ${mq(null, 'tablet')} {
      padding-bottom: 1rem;
    }
  }
`;

interface SearchForm {
  query: string;
}

const ItemsView = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const defaultQuery = useSelector(selectQuery);

  const { control, setValue } = useForm<SearchForm>({
    defaultValues: {
      query: defaultQuery,
    },
  });
  const query = useWatch({ control, name: 'query' }) ?? '';

  const handleCancel = useCallback(() => {
    setValue('query', '');
    dispatch(resetItems());
  }, [dispatch, setValue]);

  return (
    <Container>
      <Header>
        <Subtitle>{t('Search')}</Subtitle>
        <form>
          <TextFieldWithControl
            name="query"
            control={control}
            placeholder={t('Search registration number or object number')}
          />
          {query.length > 0 && (
            <Button
              type="button"
              color="neutral"
              variant="flat"
              onClick={handleCancel}
            >
              {t('Cancel')}
            </Button>
          )}
        </form>
      </Header>

      <ItemList query={query} />
    </Container>
  );
};

export default ItemsView;
